// 无数据组件
import * as React from 'react';
import './NoData.less';
interface ISProps {
  type?: string; // 不同图片、提示
  show?: boolean; // 是否显示
  msg?: string; // 文本内容
}
const NoData = (props: ISProps) => {
  const { type = '', show = false, msg = '暂无内容' } = props;
  return (
    <div className="components-nodata">
      {show && (
        <div className={`nodata nodata-${type}`}>
          <div className="nodata-img" />
          <p>{msg}</p>
        </div>
      )}
    </div>
  );
};
export default NoData;
